import { useQuery } from "@tanstack/react-query";
import { listDraftTypes } from "@/lib/api";
import { queryKeys } from "@/lib/cache/queryKeys";
import { staleTimes } from "@/lib/cache/staleTimes";
import { useAuth } from "@/lib/auth";

export function useDraftTypes() {
  const { user } = useAuth();
  const country = user?.operating_country || "JO";

  return useQuery({
    queryKey: queryKeys.draftTypes(country),
    queryFn: listDraftTypes,
    staleTime: staleTimes.draftTypes,
  });
}
